/** Swappable product identity (shell spec: keep branding replaceable). */
export const brand = {
  productName: "Clockify",
  tagline: "Time Tracking",
  helpUrl: "https://clockify.me/help",
  whatsNewUrl: "https://clockify.me/help/whats-new",
};

export function pageTitle(title?: string): string {
  return title ? `${title} • ${brand.productName}` : brand.productName;
}
